// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__pcZux","footerLogo":"Footer_footerLogo__+oYMW","footerWeb":"Footer_footerWeb__60+cl","footerMovil":"Footer_footerMovil__hTtLT"};